import React, { useState } from 'react';
import { useLingui } from '@lingui/react';
import { splitStringByLine } from '@wkda/funnel-utils';
import { useGetConsumerCarlead, useHandoverProps } from '@wkda/funnel-components';
import { Button } from '../../shared';
import { getPriceStatus } from '../../../helpers';
import { scrollTo } from '../../../helpers/scrollTo';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CollapsableFaqItem = _ref => {
  let {
    question,
    answer
  } = _ref;
  const [isCollapsed, setIsCollapsed] = useState(false);
  return /*#__PURE__*/_jsxs("article", {
    className: "accordion-item " + (isCollapsed ? 'opened' : ''),
    children: [/*#__PURE__*/_jsx("p", {
      className: "accordion-title " + (isCollapsed ? 'active' : ''),
      onClick: () => setIsCollapsed(previousState => !previousState),
      dangerouslySetInnerHTML: {
        __html: question
      }
    }), /*#__PURE__*/_jsx("div", {
      className: "accordion-content",
      children: /*#__PURE__*/_jsx("div", {
        className: "accordion-question-wrapper",
        dangerouslySetInnerHTML: {
          __html: answer
        }
      })
    })]
  });
};
export const CollapsedFaq = _ref2 => {
  let {
    type,
    headline = true,
    cta = true,
    ctaScrollTarget = 'body'
  } = _ref2;
  const {
    i18n
  } = useLingui();
  const carLeadData = useGetConsumerCarlead();
  const priceStatus = getPriceStatus(carLeadData);
  const data = useHandoverProps();
  const riskFree = data.isRiskFree;
  const title = type === 'selfeva' ? i18n._('selfInspection.faq.title') : i18n._('booking.faq.title');
  const invalidQuestionTranslation = i18n._('booking.faq.invalid.question');
  const validQuestionTranslation = i18n._('booking.faq.valid.question');
  const invalidAnswerTranslation = i18n._('booking.faq.invalid.answer');
  const validAnswerTranslation = i18n._('booking.faq.valid.answer');
  const list = type === 'carlead' ? i18n._('carlead.faq.question') : type === 'selfeva' ? i18n._('selfInspection.faq.question') : priceStatus === 'reeva' ? invalidQuestionTranslation : validQuestionTranslation;
  const answers = type === 'carlead' ? i18n._('carlead.faq.answer') : type === 'selfeva' ? i18n._('selfInspection.faq.answer') : priceStatus === 'reeva' ? invalidAnswerTranslation : validAnswerTranslation;
  const formattedAnswers = splitStringByLine(answers).filter(Boolean);
  const ctaLabel = type === 'selfeva' ? i18n._('selfInspection.faq.cta') : i18n._('booking.faq.button.label');
  const content = {
    cta: {
      text: {
        full: ctaLabel
      },
      className: 'btn btn-secondary btn-lg btn-arrow btn-gradient btn-shadow',
      action: 'goTop',
      dataLabel: 'CTA - Accordion'
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "faq-accordion chevron-right " + (riskFree ? 'risk-free' : 'balance-sheet'),
    "data-category": "FAQ",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "accordion",
      children: [headline && /*#__PURE__*/_jsx("h2", {
        className: "title",
        children: title
      }), splitStringByLine(list).filter(Boolean).map((item, index) => {
        return /*#__PURE__*/_jsx(CollapsableFaqItem, {
          question: item,
          answer: formattedAnswers[index]
        }, index);
      })]
    }), cta && /*#__PURE__*/_jsx(Button, {
      data: content.cta,
      handleClick: () => scrollTo(ctaScrollTarget)
    })]
  });
};